<template>
  <div class="content ht-100v pd-0">
    <template>
      <div ref="mainHeader" class="content-header bd-b pd-0 bg-core-light">
        <nav class="navbar navbar-expand-lg wd-100p" style="height: 59px;">
          <div class="dropdown" v-if="listSetting.mainMenu">
            <a class="navbar-brand tx-bold tx-spacing--2 order-1"
              >Байгууллагын тохиргоо</a
            >
          </div>
          <div v-else-if="listSetting.closeBtnShow">
            <a
              class="btn btn-sm pd-x-15 btn-uppercase mg-l-auto"
              @click="$emit('on-close')"
            >
              <feather type="x"></feather>
            </a>
          </div>
          <a
            class="navbar-toggler order-2"
            type="button"
            data-toggle="collapse"
            :data-target="`#navbarSupportedContent_1`"
            :aria-controls="`navbarSupportedContent_1`"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <feather type="menu" class="wd-20 ht-20"></feather>
          </a>
          <div
            class="collapse navbar-collapse order-2"
            :id="`navbarSupportedContent_1`"
          >
            <div class="mg-l-auto">
              <a
                v-if="listSetting.newBtnShow"
                class="btn btn-sm pd-x-15 btn-primary btn-uppercase text-white"
                @click="editShow(0)"
              >
                <feather type="plus" class="m-r-5"></feather>Шинэ
              </a>
              <a
                v-if="listSetting.closeBtnShow"
                @click="forceClose"
                class="btn btn-sm pd-x-15 btn-uppercase mg-l-5 btn-danger text-white"
              >
                <feather type="x" class="m-r-5"></feather>Хаах
              </a>
            </div>
          </div>
        </nav>
      </div>
      <div class="content-body pd-x-0 pd-y-0 overflow-hidden">
        <div class="container-fluid pd-x-0" id="cstmScrll">
          <div class="row no-gutters">
            <div class="col-xs-2 col-md-2 bg-core-light">
              <vue-custom-scrollbar
                :style="`height:${scrSideHeight}px`"
                :settings="{ maxScrollbarLength: 60 }"
                class="bd-t"
              >
                <!-- TODO: ene hesegt ehlel huudasnii tohirgoo bolon undsen gesen tses oruulj ireh -->
                <!-- TODO: ene hesegt bas hailt oruulj ireh -->
                <b-form class="pd-10" @keyup.enter="search()">
                  <b-form-group label="Түлхүүр үг" label-for="input-1">
                    <b-form-input id="input-1" v-model="srchSetting.key" placeholder="Түлхүүр үг" required type="text" @keyup.enter="search()"></b-form-input>
                  </b-form-group>
                  <b-form-group label="Гарчиг" label-for="input-2">
                    <b-form-input id="input-2" v-model="srchSetting.name" placeholder="Гарчиг" required type="text" @keyup.enter="search()"></b-form-input>
                  </b-form-group>
                  <b-form-group label="Утга" label-for="input-3">
                    <b-form-input id="input-3" v-model="srchSetting.value" placeholder="Утга" required type="text" @keyup.enter="search()"></b-form-input>
                  </b-form-group>
                </b-form>
              </vue-custom-scrollbar>

              <div class="d-none d-md-block text-center bd-t" ref="sideBtm">
                <div
                  class="btn-group mg-y-7"
                  role="group"
                  aria-label="Basic example"
                >
                  <button
                    @click="search()"
                    type="button"
                    class="btn btn-xs btn-light"
                  >
                    <feather type="filter" class="mg-r-5"></feather>
                    <span>Хайх</span>
                  </button>
                  <button
                    @click="init(true)"
                    type="button"
                    class="btn btn-xs btn-light"
                  >
                    <feather type="refresh-ccw" class="mg-r-5"></feather>
                    <span>Бүгд</span>
                  </button>
                </div>
              </div>
            </div>
            <div class="col-xs-10 col-md-10 bd-l">
              <div
                ref="listHeader"
                class="row no-gutters bg-list-header"
                v-show="settingsCount > 0"
              >
                <!-- <div class="wd-5p text-center tx-10 align-items-center d-flex">#</div>
                <div
                  :class="`tx-10 align-items-center d-flex pd-y-7 text-black bd-l text-uppercase lh-1`"
                  :style="`width: ${f.span}%`"
                  v-for="(f,i) in fields"
                  :key="i"
                >{{f.title}}</div> -->
                <table class="table table-bordered mg-b-0">
                  <thead>
                    <tr>
                      <th
                        :style="`width: ${f.span}%`"
                        v-for="(f, i) in fields"
                        :key="i + '_th'"
                        scope="col"
                      >
                        {{ f.title }}
                      </th>
                    </tr>
                  </thead>
                </table>
              </div>

              <vue-custom-scrollbar
                :style="`height:${scrHeight}px`"
                :settings="{ maxScrollbarLength: 60 }"
              >
                <div v-if="!loading" class="d-list">
                  <div v-if="settingsCount == 0" class>
                    <div class>
                      <div
                        class="ht-700 d-flex flex-column align-items-center justify-content-center"
                      >
                        <div class="wd-70p wd-sm-250 wd-lg-300 mg-b-15">
                          <img
                            src="assets/img/img22.png"
                            class="img-fluid"
                            alt
                          />
                        </div>
                        <p class="tx-color-03 mg-b-30">
                          Жагсаалт хоосон байна.
                        </p>
                      </div>
                    </div>
                  </div>
                  <table v-else class="table table-bordered mg-b-0 table-hover">
                    <tbody>
                      <tr v-for="(t, i) in settings" :key="i + '_td'">
                        <td style="width: 10%;" scope="row">
                          {{ (pager.current - 1) * pager.perPage + i + 1 }}
                        </td>
                        <td style="width: 20%;">{{ t.key }}</td>
                        <td style="width: 20%;">{{ t.name }}</td>
                        <td style="width: 40%; overflow-wrap: anywhere;">
                          {{ t.value }}
                        </td>
                        <td style="width: 10%;" class="text-center">
                          <a
                            class="btn btn-xs btn-primary text-white"
                            @click="editSetting(t)"
                            role="button"
                            >засах</a
                          >
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <!-- <div v-for="(t,i) in settings" :key="i" class="d-row">
                    <div
                      role="button"
                      @click="showDetail(t)"
                      class="row highlight no-gutters list-row"
                    >
                      <div class="wd-5p no-gutters align-items-center d-flex justify-content-end">
                        <div
                          class="text-right text-muted pr-1 tx-11"
                        >{{((pager.current-1)*pager.perPage) + i+1}}</div>
                        <div class="wd-25 text-center bd-l pt-1" @click.stop>
                          <input @click.stop type="checkbox" role="button" />
                        </div>
                      </div>
                      <div class="tx-12 align-items-center d-flex bd-l" style="width: 20%;">
                        <div class="pd-x-5 text">{{t.key}}</div>
                      </div>
                      <div class="tx-12 align-items-center d-flex bd-l" style="width: 20%;">
                        <div class="pd-x-5 text">{{t.name}}</div>
                      </div>
                      <div class="tx-12 align-items-center d-flex bd-l" style="width: 40%;">
                        <div class="pd-x-5 text"></div>
                      </div>
                      <div class="tx-12 align-items-center d-flex bd-l" style="width: 10%;">
                        <div class="pd-x-5 text" style="height: 30px">
                          
                        </div>
                      </div>
                    </div>
                  </div>-->
                </div>
                <div v-else></div>
              </vue-custom-scrollbar>

              <div
                ref="listFooter"
                class="py-2 d-flex justify-content-between bd-t bg-core-light"
                v-show="settingsCount > 0"
              >
                <div class="pd-x-5 pd-t-5 text-muted tx-12">
                  Нийт:
                  <span class="font-weight-bold">{{ settingsCount }}</span>
                  бичилт.
                </div>
                <div>
                  <a @click="init(true)" role="button">
                    <feather
                      type="refresh-cw"
                      class="wd-20 ht-20 text-muted mg-r-10 mg-t-5"
                    ></feather>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <b-modal v-model="modal.show" hide-header hide-footer centered>
      <div class="modal-header pd-y-20 pd-x-20 pd-sm-x-30">
        <a
          @click="modal.show = false"
          role="button"
          class="close pos-absolute t-15 r-15"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">×</span>
        </a>
        <div class="media align-items-center">
          <span class="tx-color-03 d-none d-sm-block">
            <feather type="pen-tool" class="wd-40-f ht-40-f"></feather>
          </span>
          <div class="media-body mg-sm-l-20">
            <h4 class="tx-18 tx-sm-20 mg-b-2">Байгууллагын тохиргоо</h4>
            <p class="tx-13 tx-color-03 mg-b-0">
              Тохирох утгыг бөглөөд хадгалах дарна уу
            </p>
          </div>
        </div>
        <!-- media -->
      </div>
      <div class="modal-body pd-sm-t-30 pd-sm-b-40 pd-sm-x-30">
        <div class="form-group">
          <label
            class="tx-10 tx-uppercase tx-medium tx-spacing-1 mg-b-5 tx-color-03"
            >Түлхүүр үг</label
          >
          <input
            v-if="curSetting.id == 0"
            v-model="curSetting.key"
            type="text"
            placeholder="Түлхүүр үг"
            class="form-control"
          />
          <input
            v-else
            readonly
            v-model="curSetting.key"
            type="text"
            placeholder="Түлхүүр үг"
            class="form-control"
          />
        </div>
        <div class="form-group">
          <label
            class="tx-10 tx-uppercase tx-medium tx-spacing-1 mg-b-5 tx-color-03"
            >Гарчиг</label
          >
          <input
            v-model="curSetting.name"
            type="text"
            placeholder="Гарчиг"
            class="form-control"
          />
        </div>
        <div class="form-group">
          <label
            class="tx-10 tx-uppercase tx-medium tx-spacing-1 mg-b-5 tx-color-03"
            >Утга</label
          >
          <input
            v-model="curSetting.value"
            type="text"
            placeholder="Утга"
            class="form-control"
          />
        </div>
      </div>

      <div class="modal-footer pd-x-20 pd-y-15">
        <button type="button" @click="modal.show = false" class="btn btn-white">
          Болих
        </button>
        <button type="button" @click="saveSetting()" class="btn btn-primary">
          Хадгалах
        </button>
      </div>
    </b-modal>
    <file-dialog
      :show.sync="fileDialog.show"
      :id="fileDialog.id"
      @on-hide="fileDialog.show = false"
    />
  </div>
</template>
<script>
import vueCustomScrollbar from "vue-custom-scrollbar";
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";
import { request } from "@/api/all";

export default {
  components: {
    vueCustomScrollbar,
    fileDialog: () => ({
      component: import("@/components/modules/media/preview.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    })
  },
  data: () => ({
    forceLoad: false,
    ot: -1,
    mode: 0,
    fetched: false,
    loading: false,
    listSetting: {
      newBtnShow: true,
      statisticLoad: false,
      closeBtnShow: false,
      mainMenu: true,
      chooser: false
    },
    fileDialog: {
      show: false,
      id: 0
    },
    settingsCount: 0,
    pager: {
      perPage: 50,
      current: 1
    },
    formDialog: {
      show: false,
      id: 0,
      key: 0
    },
    scrHeight: 600,
    scrSideHeight: 600,
    settingsFlat: [],
    settings: [],
    fields: [
      {
        title: "№",
        span: 10
      },
      {
        title: "Түлхүүр үг",
        span: 20
      },
      {
        title: "Гарчиг",
        span: 20
      },
      {
        title: "Утга",
        span: 40
      },
      {
        title: "Цэс",
        span: 10
      }
    ],
    modal: {
      show: false
    },
    srchSetting: {
      key: "",
      name: "",
      value: ""
    },
    curSetting: {
      id: 0,
      key: "",
      name: "",
      value: ""
    }
  }),
  props: {
    prms: {
      type: Object,
      default: () => {}
    }
  },
  beforeDestroy() {
    this.tasks = [];
    this.fields = [];
    window.removeEventListener("resize", this.getWindowHeight);
  },
  mounted() {
    if (this.prms != undefined && this.prms.objectTypeId != undefined) {
      this.forceLoad = true;
      this.$nextTick(() => {
        this.build(this.prms.objectTypeId);
      });
    } else {
      this.forceLoad = true;
      this.$nextTick(() => {
        this.build(this.$route.params.ot);
      });
    }
  },
  methods: {
    getWindowHeight() {
      if (this.formDialog.id == 0) {
        let extras =
          this.$refs.mainHeader.offsetHeight +
          this.$refs.listHeader.offsetHeight +
          this.$refs.listFooter.offsetHeight;
        let extraSide =
          this.$refs.mainHeader.offsetHeight +
          (this.listSetting.statisticLoad
            ? this.$refs.sideTop.offsetHeight
            : 0) +
          this.$refs.sideBtm.offsetHeight;

        this.scrHeight = window.innerHeight - extras;
        this.scrSideHeight = window.innerHeight - extraSide;
      }
    },
    build() {
      this.init();
    },
    filterSettings(){
      // console.log(this.srchSetting);
      this.settings = this.settingsFlat.filter(e => { 
        return e.key.includes(this.srchSetting.key) && 
        e.name.includes(this.srchSetting.name) && 
        e.value.includes(this.srchSetting.value);
      });
      // this.settingsCount = this.settings.length;
    },
    init(isRefresh = false) {
      // console.log(isRefresh);
      if(isRefresh){
        this.srchSetting.key = "";
        this.srchSetting.name = "";
        this.srchSetting.value = "";
      }

      window.addEventListener("resize", this.getWindowHeight);
      this.getWindowHeight();
      request({
        api: { method: "get", url: "Config/GetGroupSettings" },
        store: this.$store
      }).then(res => {
        if (res != false) {
          this.settingsFlat = res.data.settings;
          this.settings = res.data.settings.map(function(e) {
            e.selected = false;
            return e;
          });
          this.filterSettings();
          this.settingsCount = this.settings.length;
        }
      });
    },
    editSetting(s) {
      this.curSetting = s;
      this.$nextTick(function() {
        this.modal.show = true;
      });
    },
    editShow() {
      this.modal.render = true;
      this.curSetting = {
        id: 0,
        name: "",
        key: "",
        value: ""
      };
      this.$nextTick(function() {
        this.modal.show = true;
      });
    },
    saveSetting() {
      if (this.curSetting.key.length > 0) {
        request({
          api: { method: "post", url: "Config/EditGroupSettings" },
          store: this.$store,
          data: {
            id: this.curSetting.id,
            name: this.curSetting.name,
            key: this.curSetting.key,
            value: this.curSetting.value
          }
        }).then(res => {
          if (res != false) {
            this.init(true);
            this.modal.show = false;
            this.$bvToast.toast("Амжилттай хадгаллаа", {
              title: "Мэдэгдэл",
              autoHideDelay: 5000,
              appendToast: false,
              variant: "success",
              toaster: "b-toaster-bottom-left"
            });
          }
        });
      } else {
        this.$bvToast.toast("Түлхүүр үг хоосон байна", {
          title: "Мэдэгдэл",
          autoHideDelay: 5000,
          appendToast: false,
          variant: "warning",
          toaster: "b-toaster-bottom-left"
        });
      }
    },
    showDetail() {},
    search() {
      this.filterSettings();
    },
    dispose() {
      Object.assign(this.$data, this.$options.data());
      window.removeEventListener("resize", this.getWindowHeight);
    }
  },
  watch: {
    "$root.$route"() {
      //console.log(newRoute);
      this.dispose();
      this.$nextTick(() => {
        this.forceLoad = true;
        this.$nextTick(() => {
          this.build(this.$route.params.ot);
        });
      });
    }
  }
};
</script>
